export default {
    login_register: 'Giriş/Kayıt Ol',
    booking_confirmation_title: 'Rezervasyon Onayı',
    booking_confirmation_body: 'Rezervasyonunuz için teşekkür ederiz. Onay detaylarını aşağıda bulabilirsiniz.',
    insurance_requirements_modal_disclaimer: `Bu rezervasyonu yaparak şunları onaylıyorum: Son 5 yıl içinde herhangi bir mahkumiyetim veya trafik suçum olmadı. Hiçbir sigorta teklifim reddedilmedi, poliçem iptal edilmedi veya yenilemem reddedilmedi, hiçbir sigorta şirketi tarafından ek prim ödemem istenmedi veya özel şartlar uygulanmadı. Sürücü belgem iptal edilmedi. Hakkımda devam eden bir dava veya polis soruşturması yok. Son 5 yıl içinde hırsızlık, dolandırıcılık veya sahtekarlıkla ilgili bir mahkumiyetim yok. Görme veya işitme kaybım yok (gözlük veya işitme cihazı ile düzeltilmeyen), kalp hastalığım, diyabetim, nöbetim veya herhangi bir fiziksel ya da zihinsel engelim yok. Son 5 yıl içinde herhangi bir kazam olmadı. Bu şartları karşılamıyorsanız lütfen {0} tıklayın.`,
    insurance_requirements_here: 'buraya',
    insurance_requirements: '{0} okudum ve anladım',
    ir: 'Sigorta Gereksinimleri',
    location: 'Konum',
    pickup_location: 'Teslim Alma Noktası',
    dropoff_location: 'Teslim Etme Noktası',
    vehicle: 'Araç',
    pickup_and_dropoff: 'Teslim Alma ve Teslim Etme (yerel saat)',
    view_voucher: 'Voucheri Görüntüle',
    identity_verification_body: 'Aracı teslim almadan önce kimliğinizi doğrulamanız gerekecek',
    identity_verification_title: 'Kimlik Doğrulama',
    search_again: 'Tekrar Ara',
    refrigerated: 'soğutmalı',
    aircon_lower: 'klima',
    aircon: 'Klima',
    refrigeration: 'Soğutmalı',
    not_available: 'Drive & Go şu anda yalnızca aşağıdaki ülkelerden kimlik ve ehliyet belgelerine sahip kişiler için mevcuttur.',
    check_if_included: 'Ülkenizin dahil olup olmadığını kontrol edin.',
    included_in_booking: 'Bu rezervasyona dahil',
    cdw_with_excess: 'Muafiyetli CDW',
    theft_protection: 'Muafiyetli hırsızlık koruması',
    risk_reduction: 'Risk azaltma',
    free_extras: 'Bu rezervasyonla iki ücretsiz ekstra hakkınız var <br />.',
    continue: 'Devam Et',
    luggage_large_short_label: 'B',
    luggage_medium_short_label: 'O',
    luggage_small_short_label: 'K',
    luggage_large_long_label: 'büyük',
    luggage_medium_long_label: 'orta',
    luggage_small_long_label: 'küçük',
    fuel_unspecified_label: 'belirtilmemiş',
    transmission_manual_label: 'Manuel',
    transmission_automatic_label: 'Otomatik',
    make_a_booking: 'Rezervasyon Yap',
    pickup_date: 'Teslim Alma Tarihi',
    dropoff_date: 'Teslim Etme Tarihi',
    driver_age: 'Sürücü 30 - 65 yaş arası',
    enter_driver_age: 'Lütfen sürücünün yaşını girin',
    promo_code: 'Promosyon Kodu',
    search: 'Ara',
    dropoff_date_cannot_be_before_pickup_date: 'Teslim etme tarihi, teslim alma tarihinden önce olamaz',
    pickup_date_cannot_be_in_the_past: 'Teslim alma tarihi geçmişte olamaz',
    pickup_time_cannot_be_in_the_past: 'Teslim alma saati geçmişte olamaz',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Aynı gün ise teslim etme saati, teslim alma saatinden sonra olmalıdır',
    vehicle_filters: 'Araç filtreleri',
    reset: 'Sıfırla',
    transmission: 'Vites',
    all: 'Tümü',
    manual: 'Manuel',
    auto: 'Otomatik',
    passengers: 'Yolcu',
    vehicle_type: 'Araç tipi',
    filter: 'Filtrele',
    vehicle_search: 'Araç arama',
    edit: 'Düzenle',
    no_results: 'Filtre kriterlerinize uygun sonuç bulunamadı.',
    small_cars: 'Küçük arabalar',
    medium_cars: 'Orta arabalar',
    large_cars: 'Büyük arabalar',
    estate_cars: 'Station arabalar',
    suvs: 'SUV',
    mpvs: 'MPV',
    vans: 'Minivanlar',
    camper_vans: 'Karavanlar',
    premium: 'Premium',
    unspecified: 'belirtilmemiş',
    large: 'büyük',
    medium: 'orta',
    small: 'küçük',
    automatic: 'otomatik',
    you_have_been_refunded: 'İade işleminiz yapılmıştır.',
    please_customer_service: 'Rezervasyon yapmak için lütfen müşteri hizmetlerimizle iletişime geçin.',
    contact_customer_service: 'Müşteri hizmetleriyle iletişime geçin',
    booking_failed: 'Rezervasyonunuz bu sefer işleme alınamadı.',
    summary: 'Özet',
    reforestation_and_protection: 'Kosta Rika genelinde ormanların yeniden ağaçlandırılmasını ve korunmasını destekleyin',
    cost_of_rental: 'Kiralama ücreti',
    to_pay_now: 'Şimdi ödenecek',
    greenheart_donation: 'Green Heart bağışı',
    total_cost: 'Toplam kiralama ücreti',
    tc_agreement: '{0} okudum ve anladım.',
    tc: 'Şartlar ve Koşullar',
    receive_offers: 'E-posta ile özel teklifler almak istiyorum.',
    donate: 'Evet, {amount} bağışlamak istiyorum',
    pay_now: 'Şimdi {amount} öde',
    driver_details: 'Sürücü bilgileri',
    complete_driver_details: 'Lütfen sürücü bilgilerini tamamlayın.',
    are_you_the_driver: 'Siz sürücü müsünüz?',
    have_an_account: 'Zaten bir hesabınız var mı?',
    login: 'Giriş',
    or: 'veya',
    first_name: 'Sürücünün Adı',
    last_name: 'Sürücünün Soyadı',
    email: 'E-posta adresi',
    phone_number: 'Cep telefonu numarası',
    unable_to_save_driver_information: 'Sürücü bilgileri kaydedilemedi. Lütfen tekrar deneyin.',
    pay_online_now: 'Şimdi Öde',
    day: 'Gün',
    choose_location: 'Konum seçin',
    location_not_found: 'Üzgünüz, istediğiniz konum bulunamadı.',
    add: 'Ekle',
    remove: 'Kaldır',
    free_extra: 'Ücretsiz ekstra',
    free: 'ÜCRETSİZ!',
    fast_track_notice: 'Bu hizmet için belge menşei kısıtlamaları geçerlidir. Sadece aşağıdaki ülkelerden belgeleri olanlar için geçerlidir',
    complete_booking: 'Rezervasyonu Tamamla',
    choose_card: 'Lütfen bir kart seçin veya yeni bir kart ekleyin.',
    add_billing_details: 'Lütfen fatura bilgilerini ekleyin.',
    card_number: 'Kart numarası',
    card_holder_name: 'Kart sahibinin adı',
    card_exp: 'AA / YY',
    card_cvc: 'CVC',
    save_card: 'Kartı kaydet?',
    amount_charged: 'Kartınızdan çekilecek tutar',
    payment_confirmation: 'Rezervasyonu onayla ve öde',
    payment_methods: 'mevcut ödeme yöntemleri',
    use_saved_card: 'x kayıtlı kartı kullan',
    use_different_card: '+ farklı bir kart kullan',
    book_now: 'Şimdi rezervasyon yap',
    minimum_age: 'Sadece {age}+ yaş için',
    excess_liability: 'Muafiyet',
    security_deposit: 'Depozito',
    fuel_policy: 'Yakıt politikası',
    like_for_like: 'Aldığın gibi bırak',
    full_to_full: 'Dolu al dolu bırak',
    miles_per_rental: 'Kiralama başına {mileage} ücretsiz mil',
    km_per_rental: 'Kiralama başına {mileage} ücretsiz km',
    unlimited_mileage: 'Sınırsız kilometre',
    unlimited_mileage_km: 'Sınırsız km',
    non_amendable: 'Değiştirilemez',
    non_refundable: 'İade edilmez',
    free_cancellation_until: 'Şu tarihe kadar ücretsiz iptal',
    cancellation_in_line_with: 'Şuna uygun iptal',
    tcs: 'Şartlar ve Koşullar',
    free_extras_on_collection: 'Teslimde iki ücretsiz ekstra',
    glass_and_tyres_covered: 'Cam ve lastikler dahil',
    number_of_passengers: 'Yolcu sayısı',
    number_of_bags: 'Bagaj sayısı',
    fuel_type: 'Yakıt türü',
    co2: 'CO2',
    book_type: '{type} rezervasyonu yap',
    processing: 'İşleniyor',
    actual_price: 'Gerçek fiyat',
    tooltip: '{currencyCode} fiyatı döviz kuruna göre tahmini, {currency} fiyatı bağlayıcıdır.',
    deposit: 'Depozito',
    pay_online: 'Şimdi Öde',
    pay_online_without_extras: 'Kiralama fiyatı',
    extras_on_arrival: 'Varışta ekstralar',
    insurance_on_arrival: 'Risk azaltma - Varışta öde',
    insurance_online: 'Risk azaltma - Şimdi öde',
    extras_online: 'Ekstralar - şimdi öde',
    green_heart_donation: 'Green Heart bağışı',
    why_use_drive_and_go: 'Neden Drive & Go kullanmalısınız?',
    straight_to_car: 'Doğrudan araca',
    no_queues: 'Kuyruk yok',
    self_checkout: 'Kendi kendine teslim alma',
    cant_lose_key: 'Anahtar kaybolmaz',
    online_id_check: 'Online kimlik kontrolü',
    phone_as_key: 'Telefon anahtar olarak',
    premiumplus_benefits_includes: 'Premium Plus+ avantajları da dahil',
    book_drive_go: 'Drive & Go rezervasyonu yap',
    distance_allowance: 'Mesafe hakkı',
    duration: 'Süre',
    view_more_bookings: 'Daha Fazla Rezervasyon Gör',
    to_pay_on_arrival: 'Varışta ödenecek',
    pay_on_arrival: 'Varışta öde',
    unlimited: 'Sınırsız',
    return_date: 'Dönüş Tarihi',
    postcode: 'Posta Kodu',
    country: 'Ülke',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go şu anda yalnızca aşağıdaki ülkelerden kimlik ve ehliyet belgelerine sahip kişiler için mevcuttur:',
        drive_and_go_today: 'Drive & Go rezervasyonu bugün!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Neden Drive & Go kullanmalısınız?',
        straight_to_car: 'Doğrudan araca',
        no_queues: 'Kuyruk yok',
        self_checkout: 'Kendi kendine teslim alma',
        cannot_lose_the_key: 'Anahtar kaybolmaz',
        online_id_check: 'Online kimlik kontrolü',
        phone_as_a_key: 'Telefon anahtar olarak',
        premium_plus_benefits_also_included: 'Premium Plus+ avantajları da dahil',
        book_drive_and_go: 'Drive & Go rezervasyonu yap',
    },
    car_and_camp: {
        tent_and_equipment: 'Çadır ve ekipman',
        quick_and_easy: 'Hızlı ve kolay kurulum',
        travel_freedom: 'Seyahat özgürlüğü',
        affordable_campervan_alternative: 'Karavana uygun fiyatlı alternatif',
        lightweight_and_compact: 'Hafif ve kompakt',
        fully_insured: 'Tam sigortalı',
    },
    my_bookings: 'Rezervasyonum',
    no_bookings: 'Rezervasyon yok',
    my_profile: 'Profilim',
    no_bookings_to_display: 'Gösterilecek rezervasyon yok.',
    search_great_car_rental_deals: 'Bir sonraki seyahatiniz için harika araç kiralama fırsatlarını arayın.',
    odometer_at_collection: 'Teslimde kilometre',
    fuel_at_collection: 'Teslimde yakıt',
    start_check_in: 'Check-in başlat',
    start_collection: 'Teslim alma başlat',
    recent_bookings: 'Son rezervasyon',
    damage: {
        updated_damage_report_submitted: 'Güncellenmiş hasar raporu gönderildi. Gerekirse müşteri hizmetleri ekibimiz sizinle iletişime geçecektir.',
        add_additional_damage: 'Ek hasar ekle',
        you_may_report_additional_damage_up_to: 'Araç tesliminden sonraki 24 saate kadar ek hasar bildirebilirsiniz',
        specify_damage: 'Hasarı belirtin',
        please_choose_the_area_and_type_of_damage: 'Lütfen hasarın alanını ve türünü seçin',
        type_of_damage: 'Hasar türü',
        is_this_more_than_5_cm: "Bu 5 cm'den fazla mı?",
        please_take_or_select_a_photo: 'Lütfen bir fotoğraf çekin veya seçin',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Hasarın net göründüğünden emin olarak fotoğraf çekin',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Gerekirse başka bir fotoğraf ekleyebilirsiniz, eklemek için simgeyi seçin',
        save_image: 'Görseli Kaydet',
        save_images: 'Görselleri Kaydet',
        damage_saved_successfully: 'Hasar başarıyla kaydedildi',
        add_photo: 'Fotoğraf ekle',
    },
    checkout: {
        start_collection: 'Teslim alma başlat',
        collect_vehicle: 'Aracı teslim al',
        we_will_let_you_know_the_details: 'Kiralık aracı bulabilmeniz için konum ve detayları size bildireceğiz.',
        inspect: 'İncele',
        we_will_ask_for_four_photos_from_each_corner: 'Araçtan her köşeden dört fotoğraf ve daha önce listelenmemiş yeni hasarları isteyeceğiz.',
        fuel_and_milage: 'Yakıt & Kilometre',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Kiralamanın başında kilometre ve yakıtı onaylarsınız.',
        sign: 'İmzala',
        sign_the_rental_agreement: 'Kiralama sözleşmesini imzala.',
        away_you_go: 'İyi yolculuklar',
        you_are_free_to_take_to_the_road: 'Yola çıkmaya hazırsınız!',
        collect_your_vehicle: 'Aracınızı teslim alın',
        get_directions: 'Yol tarifi al',
        hide_directions: 'Yol tarifini gizle',
        local_time: 'yerel saat',
        tel: 'Tel',
        getting_to_the_location: 'Konuma ulaşım',
        get_vehicle_details: 'Araç detaylarını al',
        view_map: 'Haritayı Görüntüle',
        unlock_vehicle_and_continue: 'Aracı aç & devam et',
        unable_to_connect_to_vehicle: 'Araca bağlanılamıyor',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Araca bağlanılamadı - lütfen doğru aracın yanında olduğunuzdan emin olun ve tekrar deneyin.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Araç rezervasyonu bulunamadı. Lütfen daha sonra tekrar deneyin.',
        odometer_and_fuel: 'Kilometre & yakıt',
        odometer: 'Kilometre',
        please_confirm_the_odometer_and_fuel_readings: 'Mümkünse kilometre ve yakıtı onaylayın.',
        the_odometer_field_is_required: 'Kilometre alanı zorunludur',
        and_must_be_greater_than_the_checkout_odometer: '& teslim alma kilometresinden büyük olmalıdır',
        confirm: 'Onayla',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Lütfen aracın her köşesinden bir fotoğraf çekin',
        pre_existing_damage: 'Mevcut Hasar',
        no_pre_existing_damage: 'Mevcut hasar yok.',
        new_damage: 'Yeni Hasar',
        add_additional_damage: 'ek hasar ekle',
        no_new_damage_to_report: 'Rapor edilecek yeni hasar yok',
        checkout_complete: 'Teslim alma tamamlandı',
        start_rental: 'Kiralama başlat',
        congratulations_name_it_is_time_to_take_to_the_road: 'Tebrikler {customer_name}, yola çıkma zamanı!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Araç teslim alma işleminiz tamamlanamadı.',
        please_do_the_following: 'Lütfen aşağıdakileri yapın',
        remove_all_belonging_and_lock_the_vehicle: 'Tüm eşyalarınızı alın ve aracı kilitleyin.',
        lock_vehicle: 'Aracı Kilitle',
        once_you_have_contacted_customer_services: 'Müşteri hizmetleriyle iletişime geçtikten sonra',
        vehicle_location: 'Araç Konumu',
        collect_your: 'Şunu teslim al',
        from: 'Şuradan',
        key_in_glove_box: 'anahtarınız torpido gözünde',

        keyholder: {
            not_detected: 'Anahtar anahtarlıkta tespit edilmedi',
            not_detected_please_try_again: 'Lütfen anahtarınızı anahtarlığa yerleştirin ve tekrar deneyin.',

            not_installed: 'Anahtarlık takılı değil',
            not_installed_please_contact_customer_service: 'Anahtarlık takılı değil, lütfen müşteri hizmetleriyle iletişime geçin.',
        },
        keyring: {
            look_up_failed: 'Anahtarlık bulunamadı',
            look_up_failed_please_contact_customer_service: 'Anahtarlık bulunamadı, lütfen müşteri hizmetleriyle iletişime geçin.',
        },
        key: {
            invalid: 'Anahtar geçersiz',
            invalid_please_contact_customer_service: 'Anahtarınız geçersiz, lütfen müşteri hizmetleriyle iletişime geçin.',

            expired: 'Anahtarın süresi doldu',
            expired__please_contact_customer_service: 'Anahtarınızın süresi doldu, lütfen müşteri hizmetleriyle iletişime geçin.',
        },
    },
    checkin: {
        start_check_in: 'Check-in başlat',
        vehicle_location: 'Araç Konumu',
        tell_us_where_you_have_parked: 'Aracı nereye park ettiğinizi bize bildirin.',
        fuel_and_milage: 'Yakıt & Kilometre',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Kiralamanın sonunda kilometre ve yakıtı onaylarsınız.',
        inspect: 'İncele',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Kiralama sırasında oluşan yeni hasarlarla birlikte aracın her köşesinden dört fotoğraf isteyeceğiz.',
        lock: 'Kilitle',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Hiçbir eşyanız kalmadığından emin olun ve aracı kilitleyin.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Aracı nereye park ettiğinizi bize bildirin',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Araç kilitlendikten sonra tekrar açılamaz.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, lütfen hiçbir eşyanız kalmadığından emin olun, aracı kilitleyin ve gerekiyorsa fiziksel anahtarı anahtarlığa geri bırakın.',
        lock_vehicle: 'Aracı Kilitle',
        complete_check_in: "Check-in'i Tamamla",
        inspection: 'İnceleme',
        complete_vehicle_check_in: "Araç check-in'ini tamamla",
        we_are_unable_to_complete_your_vehicle_check_in: 'Araç check-in işleminiz tamamlanamadı.',
        please_contact_customer_services: 'Lütfen müşteri hizmetleriyle iletişime geçin',
        once_you_have_contacted_customer_services: 'Müşteri hizmetleriyle iletişime geçtikten sonra',
        please_amend_odometer_to_be_greater_than: "Lütfen kilometreyi {odometer_value}'den büyük olacak şekilde düzeltin",
    },
    rental_agreement: {
        rental_agreement: 'Kiralama sözleşmesi',
        agreement_between: 'Sözleşme Tarafları',
        and: 've',
        sign_rental_agreement: 'Kiralama sözleşmesini imzala',
        i_have_read_and_understood_the_terms_and_conditions: 'Şartları ve Koşulları okudum, anladım ve aracın durumunu kabul ediyorum',
    },
    additional_options: 'Ekstra Seçenekler',
    booking_details: 'Rezervasyon Detayları',
    price_for_x_days: '{qty_of_days} gün için fiyat | {qty_of_days} gün için fiyat',
    cancelled: 'İptal edildi',
    upcoming: 'Yaklaşan',
    active: 'Aktif',
    full_insurance_no_deposit: 'Tam sigorta & depozito gerekmez',
    excess: '{amount} muafiyet',
    deposit: '{amount} depozito',
    included_daily_distance: 'Günlük {distance} {unit}',
    miles: 'mil',
    kilometers: 'kilometre',
    collection_details_title: 'Teslim Detayları',
    collection_details_not_found: 'Bu konum için teslim detayları tanımlanmadı',
    free_cancellation: 'Ücretsiz İptal',
    no_deposit: 'Depozito Yok',
    benefit_from: 'Faydalanın',
    for_only_per_day: 'Sadece {price} günlük',
    upgrade_mee: 'UpgradeMee',
};
